import { AlmconnectionAdoApiClient } from "@/natsstubs/almconnection/ado/client";
import { keysToSnake } from "@/natsstubs/wire/transform";

import type { NatsRpcBackend } from "../NatsRpcBackend";
import type { UnknownRecord } from "../RpcBackend";

export function registerAdoAdapters(nats: NatsRpcBackend): void {
  const client = new AlmconnectionAdoApiClient(nats.caller);
  const cid = (args: unknown[], kwargs?: UnknownRecord): string =>
    String(args[0] ?? kwargs?.connection_id);

  nats.register("alm.ado", "alm-tools", {
    get_work_item_types: async (args: unknown[]) =>
      (await client.getAdoWorkItemTypes(cid(args))).workItemTypes,

    get_workitem_link_types: async (args: unknown[]) =>
      (await client.getAdoWorkitemLinkTypes(cid(args))).linkTypes,

    get_projects: async (args: unknown[]) => (await client.getAdoProjects(cid(args))).projects,

    get_project: async (args: unknown[], kwargs?: UnknownRecord) =>
      (await client.getAdoProjectId(cid(args, kwargs))).projectId,

    set_project: async (args: unknown[]) =>
      client.setAdoProjectId({ projectId: args[1] as string }, cid(args)),

    set_pat: async (args: unknown[], kwargs?: UnknownRecord) =>
      client.setAdoPat({ pat: kwargs?.pat as string }, cid(args, kwargs)),

    get_webhook_endpoint: async (args: unknown[], kwargs?: UnknownRecord) =>
      (await client.getAdoWebhookEndpoint(cid(args, kwargs))).url,

    get_work_item_fields: async (args: unknown[], kwargs?: UnknownRecord) =>
      (
        await client.getAdoWorkItemFields(
          { referenceName: kwargs?.ref_name as string },
          cid(args, kwargs),
        )
      ).fields,

    get_team_mapping: async (args: unknown[]) =>
      keysToSnake((await client.getAdoTeamMapping(cid(args))).mapping),

    validate_area_path: async (args: unknown[], kwargs?: UnknownRecord) =>
      (
        await client.validateAdoAreaPath(
          { areaPath: kwargs?.area_path as string },
          cid(args, kwargs),
        )
      ).path ?? false,

    validate_iteration_path: async (args: unknown[], kwargs?: UnknownRecord) =>
      (
        await client.validateAdoIterationPath(
          { iterationPath: kwargs?.iteration_path as string },
          cid(args, kwargs),
        )
      ).path ?? false,
  });
}
